import { IconPropsType } from '..';

export const GraphIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="general=graph, betting=default, statuses=default, arrows=default, toggleables=default, signs=default, menus=default, casino=default">
      <g id="Group 1942">
        <g id="Vector">
          <path d="M14.0716 5.40001H10.8568V17.6666H14.0716V5.40001Z" />
          <path d="M9.14319 8.46663H5.92839V17.6666H9.14319V8.46663Z" />
          <path d="M4.2148 11.5333H1V17.6666H4.2148V11.5333Z" />
          <path d="M19 2.33331H15.7852V17.6666H19V2.33331Z" />
        </g>
      </g>
    </g>
  </svg>
);
